import React from 'react';

import { iconMap } from '../../icons/iconMap.ts';
import type { A2UIComponentDefinition } from '../../types/A2UIComponents.types.tsx';
import type { A2UIIconProps } from '../../types/A2UIComponents.types.tsx';

type Props = {
	definition: A2UIComponentDefinition;
};

export const A2UIIcon = ({ definition }: Props): React.JSX.Element | null => {
	const def = definition as A2UIIconProps;
	const label = def.accessibility?.label ?? '';

	// Custom SVG path
	if (typeof def.name === 'object' && def.name.path) {
		return (
			<svg width="24" height="24" viewBox="0 0 24 24" role="img" aria-label={label}>
				<path d={def.name.path} fill="currentColor" />
			</svg>
		);
	}

	// Predefined icon name
	if (typeof def.name === 'string') {
		const IconComponent = iconMap[def.name];
		if (IconComponent) {
			return <IconComponent label={label} />;
		}
		// Fallback: render nothing for unknown icons
	}

	return null;
};
